import { NEW_CONVERSATION_NAME } from './constants';

const MAX_PROMPT_NAME_LENGTH = 50;

/** A provisional title until the sandbox sends the generated one. */
export function conversationNameFromPrompt(prompt: string): string {
  const line = prompt.replace(/\s+/g, ' ').trim();
  if (!line) return NEW_CONVERSATION_NAME;
  if (line.length <= MAX_PROMPT_NAME_LENGTH) return line;
  const cut = line.slice(0, MAX_PROMPT_NAME_LENGTH);
  const lastSpace = cut.lastIndexOf(' ');
  return `${(lastSpace > 0 ? cut.slice(0, lastSpace) : cut).trimEnd()}…`;
}
